import React, { useEffect } from 'react';
import TableComponent from '../common/TableComponent';
import { changeLog } from '../../constants/columns/changelog/changeLog';
import { useAppSelector } from '../../store/hooks/StoreHooks';
import WidgetLoader from '../common/widgetloader';
import { useParams } from 'react-router-dom';

const Changelog: React.FC = () => {
    const { changeLog: changeLogData, loading } = useAppSelector((state) => state?.comments);
    const [caseName, setCaseName] = React.useState<{oldName: string, newName:string}>({oldName:"Old Value", newName:"New Value"});
    const { projectAndAffiliations } = useAppSelector((state) => state?.projectHeader);
    const { ID, caseID } = useParams();
    const projectID = ID?.split("projectID=")?.[1] || "";
    const caseId = caseID?.split("caseID=")?.[1] || "";
    const projectId = caseId || projectID;

    useEffect(() =>{
        let newVal = projectAndAffiliations?.find((item: any) => item?.projectID === projectId)
        let oldVal = projectAndAffiliations?.find((item: any) => item?.projectID === newVal?.copyFrom)
        setCaseName({oldName: oldVal?.displayCaseName || "Old Value", newName: newVal?.displayCaseName || "New Value"})
    },[projectAndAffiliations, changeLogData, projectId])

    return (
        <div>
            {
                loading ? <div className='h-screen'><WidgetLoader isLoading={loading} /></div> :
                    <TableComponent
                        restrictHeight={false}
                        overFlowClass="overflow-auto"
                        data={changeLogData || []}
                        columns={[
                            ...changeLog(caseName?.oldName, caseName?.newName)
                        ]}
                        rowsPerPage={1}
                    />
            }
        </div>
    );
};

export default Changelog;
